import type { partyRoleApiSchema } from "@/components/Forms/schema/partyRoleSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";
import type { z } from "zod";

type PartyRoleForApi = z.infer<typeof partyRoleApiSchema>;

export const useSavePartyRole = (
    partyRoleUUID: string,
): UseMutationResult<void, Error, PartyRoleForApi> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ ...attributes }) => {
            const response = await fetch(apiUrl(`/party-role/save/${partyRoleUUID}`), {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    data: {
                        id: partyRoleUUID,
                        type: "partyRole",
                        attributes: {
                            ...attributes,
                            id: null,
                        },
                    },
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["party-roles"],
            });
        },
    });
};
